export default __webpack_public_path__ + "static/media/egurrola_winter.84337ee8.jpg";